import React from "react";
import { Dropdown, Menu } from "antd";
import styled from "styled-components";
import { CompassParagraph, StyledAnchor } from "../common/styledComponents";
import { ElementContainer } from "../containers/styledComponents";
import { Icon, IconContainer } from "./styledComponents";
import { greyText } from "../../styles";

// Styled components
const StyledDropdown = styled(Dropdown)`
  cursor: pointer;
`;

const StyledMenu = styled(Menu)`
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const CompassDropdown: React.FC<DropdownPropsRenderer> = ({
  icon,
  title,
  children,
  placement = "bottomLeft",
  customDisplayComponent,
}) => {
  const menu = (
    <StyledMenu>
      {React.Children.map(children, (child, index) => (
        <Menu.Item key={index}>{child}</Menu.Item>
      ))}
    </StyledMenu>
  );

  return (
    <StyledDropdown overlay={menu} placement={placement} trigger={["hover"]}>
      <StyledAnchor onClick={(e): void => e.preventDefault()}>
        <ElementContainer cursor="pointer" jc="center" ai="center">
          <CompassParagraph color={greyText} cursor="pointer" mr={1}>
            {title}
          </CompassParagraph>
          {icon && (
            <IconContainer m={1} p={6}>
              <Icon src={icon} alt="icon" />
            </IconContainer>
          )}
          {customDisplayComponent && customDisplayComponent}
        </ElementContainer>
      </StyledAnchor>
    </StyledDropdown>
  );
};

export interface DropdownProps {
  title: string;
  icon?: string | null;
  placement?:
    | "bottomLeft"
    | "bottomCenter"
    | "bottomRight"
    | "topLeft"
    | "topCenter"
    | "topRight";
}

export interface DropdownPropsRenderer extends DropdownProps {
  children: React.ReactNode;
  customDisplayComponent?: JSX.Element; // Adding CustomDisplayComponent as an optional prop
}
